import React from 'react';
import styled from 'styled-components/macro';
import moment from 'moment';
import { INewsItem } from 'constants/types';
import Breakpoints from 'themes/constants/breakpoints';
import { textTrim } from 'utils/text';
import placeholder from 'media/images/placeholder.jpg';
import get from 'lodash.get';
import { useHistory, useRouteMatch } from 'react-router-dom';
import RoutePath from 'routes/constants/routes';

// Styles
const Wrap = styled.div`
    display: flex;
    flex-flow: column nowrap;
    background: ${({ theme }) => theme.background.card.news};
    color: ${({ theme }) => theme.palette.black};
    border-radius: ${({ theme }) => theme.borderRadius.card.news};
    box-shadow: ${({ theme }) => theme.boxShadow.card.news};
    cursor: pointer;
    overflow: hidden;
    ${({ theme }) => theme.paddings.inner.card};
    width: 100%;
    max-width: 100%;
    @media only screen and (${Breakpoints.LAPTOP}) {
        box-shadow: ${({ theme }) => theme.boxShadow.card.journal};
    }
    @media only screen and (${Breakpoints.DESKTOP_S}) {
        max-width: 320px;
    }
`;
const Caption = styled.div`
    display: flex;
    flex-flow: column nowrap;
    flex-grow: 1;
    min-height: 80px;
`;
const Img = styled.div`
    position: relative;
    height: 0;
    padding-bottom: 100%;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    margin-bottom: 6px;
    & > img {
        position: absolute;
        height: 100%;
        width: 100%;
        background: ${({ theme }) => theme.background.skeleton};
        border-radius: ${({ theme }) => theme.borderRadius.card.news};
        object-fit: cover;
    }
`;
const HeadCaption = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-end;
    margin: 0 0 3px;
`;
const PublishDate = styled.div`
    font-size: 10px;
    line-height: 1.2;
    font-weight: 700;
`;
const Category = styled.div`
    font-size: 12px;
    line-height: 1.2;
    color: ${({ theme }) => theme.palette.secondary};
`;
const Description = styled.div`
    font-size: 12px;
    line-height: 15px;
    margin: auto 0;
    @media only screen and (${Breakpoints.LAPTOP}) {
        font-size: 14px;
    }
`;

// Interfaces
interface INewsCard {
  item: INewsItem
}
export interface IMatchParams {
  categoryId: string;
}

// Component
const NewsCard = ({ item }: INewsCard) => {
  const {
    publishDate = null,
    description = '',
    catgoryName = '',
    id,
  } = item;

  const history = useHistory();
  const match = useRouteMatch<IMatchParams>();
  const categoryId = Number(match.params.categoryId) || 0;
  const publishDateFormatted = moment(publishDate).format('DD MMM YYYY');

  const imgSrc = get(item, ['preview'], placeholder);

  const handleRedirect = () => history.push(`${RoutePath.NEWS_PATH}/${categoryId}/detail/${id}`);

  return (
    <Wrap onClick={handleRedirect}>
      <Img>
        <img
          src={imgSrc}
          alt={description}
          decoding="async"
          onError={(e: any) => {
            e.target.onerror = null;
            e.target.src = placeholder;
          }}
        />
      </Img>
      <Caption>
        <HeadCaption>
          <PublishDate>{publishDateFormatted}</PublishDate>
          <Category>{catgoryName}</Category>
        </HeadCaption>
        <Description>{textTrim(description)}</Description>
      </Caption>
    </Wrap>
  );
};

export default NewsCard;
